import { IVeriListRow } from "@directives/_veri/veriList/veriList.component";
import { TranslationService } from "@services/translation.service";
import { UnitConversionService } from "@services/unitConversion.service";
import { VeriDate } from "@services/veriDate.service";
import { ITemperatureProfile } from "@temperature/_models/temperature/ITemperatureProfile";
import { TemperatureService } from "@temperature/_services/temperature.service";
import * as angular from "angular";
import "./temperatureProfilesEdit.scss";

class TemperatureProfilesEditComponentController implements angular.IComponentController {

    profileRows: IVeriListRow<ITemperatureProfile>[] = [];
    selectedProfile: ITemperatureProfile;
    profilesList: ITemperatureProfile[];

    profileCreatedDate: string;
    profileLastUpdated: string;

    errorMessage: string;
    checkboxTicked: boolean;

    loading: boolean;

    decimalCheck = /^-?[0-9][^\.]*$/;

    static $inject = ["temperatureService", "veriDate", "unitConversionService", "translationService"];

    constructor(
        private readonly temperatureService: TemperatureService,
        private readonly veriDateService: VeriDate,
        private readonly unitConversionService: UnitConversionService,
        private readonly translationService: TranslationService
    ) {
    }

    $onInit() {
        this.loadProfiles();
    }

    addNewProfile() {
        this.errorMessage = '';

        var newProfile: ITemperatureProfile = {
            Id: 0,
            Name: this.translationService.t("temperatureProfilesEdit.newProfile"),
            UpperBound: 0,
            LowerBound: 0,
            activeState: 1,
        };

        this.setSelectedProfile(newProfile);
    }

    checkValidity() {
        this.errorMessage = '';

        if (!this.selectedProfile.LowerBound || !this.selectedProfile.UpperBound) {
            this.errorMessage = this.translationService.t("temperatureProfilesEdit.enterValidTemperatures");
        }

        if (this.selectedProfile.LowerBound == 0 && this.selectedProfile.UpperBound == 0 || this.selectedProfile.LowerBound == 0 && this.selectedProfile.UpperBound || this.selectedProfile.UpperBound == 0 && this.selectedProfile.LowerBound) {
            this.errorMessage = '';
        }

        if (this.selectedProfile.LowerBound > this.selectedProfile.UpperBound) {
            this.errorMessage = this.translationService.t("temperatureProfilesEdit.minGreaterThanMax");
        }

        if (this.selectedProfile.LowerBound < -300 || this.selectedProfile.LowerBound > 300 || this.selectedProfile.UpperBound < -300 || this.selectedProfile.UpperBound > 300) {
            this.errorMessage = this.translationService.t("temperatureProfilesEdit.tempsExceededBounds");
        }
    }

    checkNameValidity() {
        this.errorMessage = '';

        if (!this.selectedProfile.Name) {
            this.errorMessage = this.translationService.t("temperatureProfilesEdit.enterProfileName");
            return;
        }
       
        this.profilesList.forEach(profile => {
            if (this.selectedProfile.Name == profile.Name && this.selectedProfile.Id !== profile.Id) {
                this.errorMessage = this.translationService.t("temperatureProfilesEdit.nameExists");
            }
        });

        this.checkValidity();
    }

    deleteProfile() {
        this.selectedProfile.activeState = 0;
        this.selectedProfile = null;
    }

    saveProfile() {
        if (!this.selectedProfile) {
            return;
        }

        this.loading = true;

        this.selectedProfile.LowerBound = this.unitConversionService.convertTemperatureForSaving(this.selectedProfile.LowerBound);
        this.selectedProfile.UpperBound = this.unitConversionService.convertTemperatureForSaving(this.selectedProfile.UpperBound);

        this.temperatureService.saveTemperatureProfile(this.selectedProfile)
            .then(() => {
                this.loadProfiles(true).then(() => {
                    this.selectedProfile = null;
                    this.loading = false;
                });
            });
    }

    setSelectedProfile(profile: ITemperatureProfile) {
        if (this.selectedProfile && this.selectedProfile.Id === profile.Id) {
            this.selectedProfile = null;
            return;
        }

        this.errorMessage = '';

        this.profileCreatedDate = this.veriDateService.formatDate(profile.Created);
        this.profileLastUpdated = this.veriDateService.formatDate(profile.Updated);

        this.selectedProfile = angular.copy(profile);
        this.checkboxTicked = false;
    }

    // ---------

    private loadProfiles(invalidateCache = false): angular.IPromise<any> {
        this.loading = true;

        return this.temperatureService.getTemperatureProfiles(invalidateCache)
            .then(profiles => {

                profiles.forEach(profile => {
                    profile.LowerBound = this.unitConversionService.convertTemperature(profile.LowerBound);
                    profile.UpperBound = this.unitConversionService.convertTemperature(profile.UpperBound);
                })

                this.profilesList = profiles;
                this.createProfileRows(this.profilesList);
                this.loading = false;
            });
    }

    private createProfileRows(profiles: ITemperatureProfile[]) {
        this.profileRows = [];

        profiles.forEach(profile => {

            this.profileRows.push({
                id: profile.Id,
                contents: profile.Name,
                data: profile,
                sortData: profile.Id
            });
        });
    }
}

export class TemperatureProfilesEditComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
        };

        this.controller = TemperatureProfilesEditComponentController;
        this.template = require("./temperatureProfilesEdit.html");
    }
}
